import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _modalDimensions;
var ModalSizes = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  XLARGE: 'xlarge',
  MAX: 'max'
};
var modalDimensions = (_modalDimensions = {}, _defineProperty(_modalDimensions, ModalSizes.SMALL, {
  height: '20vh',
  minHeight: '320px'
}), _defineProperty(_modalDimensions, ModalSizes.MEDIUM, {
  height: '40vh',
  minHeight: '520px'
}), _defineProperty(_modalDimensions, ModalSizes.LARGE, {
  height: '70vh',
  minHeight: '720px'
}), _defineProperty(_modalDimensions, ModalSizes.XLARGE, {
  height: '90vh'
}), _defineProperty(_modalDimensions, ModalSizes.MAX, {
  height: '100%'
}), _modalDimensions);
export var getModalDimensions = function getModalDimensions(size) {
  return modalDimensions[size];
};